import ReserveDeskWithApi from './ReserveDeskWithApi';

export default ReserveDeskWithApi;
